/* eslint-disable */

export const requestPermission = () => {
    cordova.plugins.firebase.messaging.requestPermission({forceShow: true})
    .then(() => {
        console.log("Push messaging is allowed");
    }).catch(e => {
        console.warn("Push messaging is NOT allowed");
    });
}

export const registerOnMessage = (callback) => {
    
    if(typeof callback === "function"){
        
        cordova.plugins.firebase.messaging.onMessage(function(payload) {
            callback(payload, "FOREGROUND");
        });
    
        cordova.plugins.firebase.messaging.onBackgroundMessage(function(payload) {
            callback(payload, "BACKGROUND");
        });
    }

}

export const registerOnToken = (callback) => {
    
    if(typeof callback === "function"){
        cordova.plugins.firebase.messaging.getToken().then(function(token) {
            callback(token);
        });       
    }
}

export const getOnToken = () => {
    return cordova.plugins.firebase.messaging.getToken();
}

export const subscribeToTopic = () => {
    cordova.plugins.firebase.messaging.subscribe("geral");
	if(device.platform == "iOS") {
        cordova.plugins.firebase.messaging.subscribe("ios");
    } else if (device.platform === 'Android') {
        cordova.plugins.firebase.messaging.subscribe("android");
    }
}

export const unsubscribeToTopic = () => {
    cordova.plugins.firebase.messaging.unsubscribe("geral");
	if(device.platform == "iOS") {
        cordova.plugins.firebase.messaging.unsubscribe("ios");
    } else if (device.platform === 'Android') {
        cordova.plugins.firebase.messaging.unsubscribe("android");
    }
}

export const FingerPrintIsAvailable = (callbackSucess, callbackError) => {        
    Fingerprint.isAvailable(callbackSucess, callbackError);   
}
export const FingerPrintShow = (callbackSucess, callbackError) => {
    try {
       
        const optionalParameters = {
            title:'Meu INSS',
            subtitle:'Acesso com biometria digital já cadastrada.',            
            description: "Toque no sensor de digital do seu celular.",
            cancelButtonTitle:'Cancelar'
        }
        Fingerprint.show(optionalParameters, callbackSucess, callbackError);
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}

// Camera
export const captureImage = (onSuccess, onFail) => {
    navigator.camera.getPicture(onSuccess, onFail, {
        quality: 50,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        cameraDirection: Camera.Direction.FRONT,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: false,
        saveToPhotoAlbum: false,
        targetWidth: 300,
        targetHeight: 300,
        correctOrientation: true
    });
}

// Camera
export const captureImageHighDefinition = (onSuccess, onFail) => {
    navigator.camera.getPicture(onSuccess, onFail, {
        quality: 80,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        cameraDirection: Camera.Direction.BACK,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: false,
        saveToPhotoAlbum: false,
        targetWidth: 1080,
        targetHeight: 1920,
        correctOrientation: true
    });
}

export const getImageBase64 = imageURI => {
    return Camera.convertFileSrc(imageURI);
}
